export const LOCALE_KEY = '__LOCALE__'
export const APP_DARK_MODE_KEY_ = '__APP__DARK__MODE__'

export enum CacheTypeEnum {
  SESSION,
  LOCAL,
}
